import { Check, Clock3, TriangleAlert } from "lucide-react";

interface StatusBadgeProps {
  status: string;
  compact?: boolean;
}

export function StatusBadge({ status, compact = false }: StatusBadgeProps) {
  const displayStatus =
    {
      preview_ready: "预览就绪",
      queued: "已排队",
      leased: "任务已领取",
      running: "生成中",
      waiting_provider: "供应商已接单",
      downloading: "下载产物中",
      composing: "合成中",
      completed: "已完成",
      failed: "失败",
      cancelled: "已取消",
      reconciliation_required: "需人工核对",
      mock_completed: "Mock 已完成",
      mock_reserved: "Mock 已登记",
    }[status] ?? status;
  const isComplete =
    status === "completed" ||
    status === "已通过" ||
    status === "mock_completed" ||
    status === "mock_reserved";
  const isWarning =
    status === "需修改" ||
    status === "已驳回" ||
    status === "error" ||
    status === "failed";
  const tone = isComplete ? "success" : isWarning ? "danger" : "pending";
  const Icon = isComplete ? Check : isWarning ? TriangleAlert : Clock3;

  return (
    <span className={`status-badge status-${tone} ${compact ? "is-compact" : ""}`}>
      <Icon size={compact ? 12 : 14} strokeWidth={2} aria-hidden="true" />
      {displayStatus}
    </span>
  );
}
